<script setup lang="ts">
const props = defineProps<{
  name: string,
}>()

const { inputMode, game, moves, addSwap, addOption10 } = useBoard(props.name)

const yesLabel = computed<string>(() => getOpeningRuleController(game.value.openingRule).getSwapYesLabel(moves.value))
const noLabel = computed<string>(() => getOpeningRuleController(game.value.openingRule).getSwapNoLabel(moves.value))
const isEnableOption10 = computed<boolean>(() => {
  const openingRuleController = getOpeningRuleController(game.value.openingRule)
  return openingRuleController.isEnableOption10 ? openingRuleController.isEnableOption10(moves.value) : false
})

const dialog = ref(false)

watch(inputMode, (value) => {
  if (value === 'swap') {
    dialog.value = true
  } else if (dialog.value === true) {
    dialog.value = false
  }
})

const handleClickOption10 = () => {
  addOption10()
  dialog.value = false
}

const handleClickOfferer = () => {
  addSwap(false)
  dialog.value = false
}

const handleClickSelector = () => {
  addSwap(true)
  dialog.value = false
}

onMounted(() => {
  dialog.value = inputMode.value === 'swap'
})
</script>

<template>
  <v-snackbar
    v-model="dialog"
    :attach="`#${props.name}`"
    absolute
    :timeout="-1"
  >
    <span class="text-caption">
      交換しますか
    </span>
    <template #actions>
      <v-btn
        v-if="isEnableOption10"
        variant="outlined"
        size="small"
        @click="handleClickOption10"
      >
        {{ '10題提示' }}
      </v-btn>
      <v-btn
        class="ml-2"
        variant="outlined"
        size="small"
        @click="handleClickOfferer"
      >
        {{ noLabel }}
      </v-btn>
      <v-btn
        class="ml-2"
        variant="outlined"
        size="small"
        @click="handleClickSelector"
      >
        {{ yesLabel }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
